import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {LOCAL_STORAGE_KEYS} from "../../consts";
import type {AppBettingPromotionDisplayModel} from "../../app/models/app-betting-promotion-display-model";
import {LocalStorageUtils} from "../../../infrastructure/utils/local-storage.utils";
import {POPUP_DISPLAY} from "../../models/popup/consts";

export class BettingPromotionBaseHandler extends ActionHandler {
  localStorageUtils: LocalStorageUtils;
  popupId: String = POPUP_DISPLAY.AUTO_DISPLAY_POPUPS.bp

  static injectables = [...ActionHandler.injectables, LocalStorageUtils];

  constructor(localStorageUtils: LocalStorageUtils) {
    super();

    this.localStorageUtils = localStorageUtils;
  }

  updateLocalStorageModel() {
    this.localStorageUtils.setJSON(LOCAL_STORAGE_KEYS.bettingPromotion, this.appStore.state.appBettingPromotionDisplayModel.localStorageModel);
  }

  get model(): AppBettingPromotionDisplayModel {
    return this.appStore.state.appBettingPromotionDisplayModel;
  }

}
